import { GAME_TYPES } from '../../model/navModel';
import {
    NeighborIcon, FairIcon, KillerIcon, DozorIcon, LegendIcon, DemocracyIcon, BetIcon, TeamTaskIcon
} from '../../model/icons';

// Игры смены для карточек-тумблеров (порядок как в верстке). type === GameType бэкенда.
export const SHIFT_GAMES = Object.freeze([
    { type: GAME_TYPES.NEIGHBOR, label: 'Насоли соседу', description: 'Игра по поиску кодов и покупки заданий', Icon: NeighborIcon },
    { type: GAME_TYPES.FAIR, label: 'Ярмарка', description: 'Ярмарка с лотами и аукционами', Icon: FairIcon },
    { type: GAME_TYPES.KILLER, label: 'Киллер', description: 'Игра на выбывание с целями', Icon: KillerIcon },
    { type: GAME_TYPES.DOZOR, label: 'Дозор', description: 'Ночной квест с точками и заданиями (скоро)', Icon: DozorIcon, disabled: true },
    { type: GAME_TYPES.LEGEND, label: 'Легенды', description: 'Командный квест с историей лагеря', Icon: LegendIcon },
    { type: GAME_TYPES.DEMOCRACY, label: 'Демократия', description: 'Голосования и санкции', Icon: DemocracyIcon },
    { type: GAME_TYPES.BET, label: 'Ставки', description: 'Ставки на события', Icon: BetIcon },
    { type: GAME_TYPES.TEAM_TASK, label: 'Командные задания', description: 'Задания на смену с наградой в Соседе', Icon: TeamTaskIcon }
]);
